/*
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-12-02 11:20:59
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-12-03 15:06:54
 * @FilePath: \carpooling-vue\src\views\clockIn\api\checkin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  buildUserPayload,
  clockInRequest,
  ensureClockInUser,
  normalizeRecord
} from './client'
import moment from 'moment'

export async function submitCheckin(payload = {}) {
  const res = await clockInRequest({
    url: '/postCheckInRecord',
    method: 'POST',
    data: buildUserPayload({
      ImageUrls: payload.image_urls || [],
      Note: payload.note || ''
    })
  })
  console.log("submitCheckin data", buildUserPayload({
      ImageUrls: payload.image_urls || [],
      Note: payload.note || ''
    }));
  return normalizeRecord(res.data || {})
}

export async function getMyCheckins(params = {}) {
  const user = ensureClockInUser()
  if(!user || !user.id){
    throw new Error('未获取到用户信息，请先登录')
  }
  const res = await clockInRequest({
    url: '/getMyCheckInList',
    method: 'GET',
    params: {
      UserId: user.id,
      page: params.page || 1,
      pageSize: params.pageSize || 50,
      startDate: params.startDate || moment().subtract(29, 'days').format('YYYY-MM-DD'),
      endDate: params.endDate || moment().format('YYYY-MM-DD')
    }
  })
  return (res.data || []).map(normalizeRecord)
}

export async function listCheckins(params = {}) {
  const res = await clockInRequest({
    url: '/getCheckInList',
    method: 'GET',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 200,
      dept: params.dept,
      area: params.area,
      keyword: params.keyword,
      startDate: params.startDate || moment().subtract(29, 'days').format('YYYY-MM-DD'),
      endDate: params.endDate || moment().format('YYYY-MM-DD')
    }
  })
  return {
    list: (res.data || []).map(normalizeRecord),
    count: res.count || 0,
    page: res.page || 1,
    pageSize: res.pageSize || 200
  }
}

export async function getCheckinDetail(id) {
  if (!id) return null
  const result = await listCheckins({ recordId: id, pageSize: 1 })
  return result.list[0] || null
}